import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function GdprLabel({ htmlFor }) {
  const { t, lp } = useLanguage();
  return (
    <label htmlFor={htmlFor} className="text-[11px] text-[#A8A6A0] leading-relaxed font-light">
      {t("form.gdpr")}{" "}
      <Link to={lp("/privacidade")} target="_blank" className="underline underline-offset-4 text-[#E8E6E1] hover:text-[#C2A675] transition-colors">
        {t("form.gdpr_link")}
      </Link>
      .
    </label>
  );
}
